import script from "./CustomTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomTab.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__